import { useState } from 'react';
import { fetchGameListPermissions } from '@/pages/home/services/search';
import { getProjectInformation } from '@gp/services/projectDetail';
import { history } from 'umi';
import { useDeepCompareEffect } from 'ahooks';
import { getIntelligenceGamePath } from '@/pages/home/utils/utils';
import { fetchCommonConditions } from '@gp/services/filter';

// 项目详情公共hooks
const useProjectsInfo = (props: any) => {
  const { urlProjectId } = props || {};

  const [gameInformationDataValue, setGameInformationDataValue] = useState<any>({});
  const [intelligenceId, setIntelligenceId] = useState('');
  const [projectId, setProjectId] = useState(urlProjectId || '');
  const [showOpinion, setShowOpinion] = useState(false);
  const [opinionId, setOpinionId] = useState('');
  const [entityType, setEntityType] = useState('');
  const [gameInformationLoading, setGameInformationLoading] = useState(false);
  const [milestoneCategory, setMilestoneCategory] = useState({});
  const [actionItemCategory, setActionItemCategory] = useState([]);

  useDeepCompareEffect(() => {
    if (urlProjectId) {
      setProjectId(urlProjectId);
    }
  }, [urlProjectId]);
  // 获取舆情权限数据
  const getGameOpinionsPermissions = async (opinionIdValue: any) => {
    // 获取对应游戏类型ID数组参数
    const idList = [opinionIdValue];
    const paramsOpinions = {
      edition_unified_ids: idList,
    };

    // 获取到所有游戏类型对应舆情权限
    try {
      const resultOpinion = await fetchGameListPermissions(paramsOpinions);
      const { list: opinionList = [] } = resultOpinion?.data || {};
      // 根据当前游戏类型，获取游戏详情舆情是否展示，即是否有舆情数据，并返回对应游戏类型id
      if (Array.isArray(opinionList) && opinionList?.length > 0) {
        const opinionObj = opinionList?.[0] || {};
        setShowOpinion(opinionObj?.opinion_permissions ?? false);
      }
    } catch (err) {
      setShowOpinion(false);
      setOpinionId('');
    }
  };

  // 调用project详情信息
  const fetchGameInformationRun = async (projectIdTemp = projectId) => {
    try {
      setGameInformationLoading(true);
      const res = await getProjectInformation({ id: projectIdTemp });
      const { data } = res || {};
      const {
        intelligence_id: intelligenceIdValue,
        opinion_id: opinionIdValue,
        intelligence_entity_type: entityType,
      } = data || {};
      setGameInformationDataValue(res);
      setIntelligenceId(intelligenceIdValue);
      setOpinionId(opinionIdValue);
      setEntityType(entityType);
      if (intelligenceIdValue) {
        getGameOpinionsPermissions(intelligenceIdValue);
      }
    } catch (exception) {
      console.error(exception);
    } finally {
      setGameInformationLoading(false);
    }
  };

  // 调用详情cond数据
  const fetchGameInforCond = async () => {
    try {
      const commonCondParams = {
        milestone_category: [],
        action_item_category: [],
      };
      const res = await fetchCommonConditions(commonCondParams);
      const { milestone_category: milestoneCategoryValue } = res || {};
      setMilestoneCategory(milestoneCategoryValue || {});
      setActionItemCategory(res?.action_item_category || []);
    } catch (exception) {
      console.error(exception);
    } finally {
      setGameInformationLoading(false);
    }
  };

  // 获取跳转链接
  const getJumpUrl = (id: string, type: string, entityTypeTemp: string) => {
    let jumpUrl = '';
    if (type === 'Intelligence') {
      jumpUrl = getIntelligenceGamePath(id, entityTypeTemp || 'pc', '');
    } else if (type === 'Opinions') {
      jumpUrl = `/opinion/Overview/KeyMetrics?gameid=${id}`;
    }
    return jumpUrl;
  };

  // 点击跳转
  const onClickJump = (id: string, type: string, entityTypeTemp: string) => {
    history.push(getJumpUrl(id, type, entityTypeTemp));
  };

  return {
    fetchGameInformationRun,
    showOpinion,
    opinionId,
    gameInformationDataValue,
    gameInformationLoading,
    intelligenceId,
    setProjectId,
    projectId,
    onClickJump,
    getJumpUrl,
    entityType,
    fetchGameInforCond,
    milestoneCategory,
    actionItemCategory,
  };
};

export default useProjectsInfo;
